"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketSubmissionPrizeDTO = void 0;
class TicketSubmissionPrizeDTO {
    static JsonToTicketSubmissionPrizeDTO(data) {
        return new TicketSubmissionPrizeDTO(data);
    }
    constructor(data) {
        this.id = data.id;
        this.externalId = data.externalId;
        this.prizeType = data.prizeType;
        this.amount = data.amount;
        this.status = data.status;
        this.baseAmount = data.baseAmount;
        this.bonusAmount = data.bonusAmount;
        this.extraData = data.extraData;
        this.token = data.token;
        this.superBonuses = data.superBonuses;
        this.draw = data.draw;
        this.preassigned = data.preassigned;
        this.hasWinningTicket = data.hasWinningTicket;
        this.prizeLevelBreakdown = data.prizeLevelBreakdown;
        this.promotionId = data.promotionId;
    }
}
exports.TicketSubmissionPrizeDTO = TicketSubmissionPrizeDTO;
//# sourceMappingURL=TicketSubmissionPrizeDTO.js.map